/* Horizontal wheel / two-finger-trackpad scrolling for co-flickity carousels — ON BY DEFAULT for
   every [data-co-flickity] carousel on a page that loads this script (all flickity sections load it
   next to co-flickity.js). Opt OUT per carousel with `data-co-flickity-no-wheel` (e.g. the homepage
   hero). The legacy opt-in attribute `data-co-flickity-wheel` is redundant now but harmless.

   Native CSS overflow-x sliders scroll horizontally with a trackpad's two-finger swipe or Shift+wheel
   because they're real scroll containers; a Flickity carousel isn't, so it ignores those gestures (and
   on macOS a two-finger horizontal swipe triggers the browser's back/forward navigation instead). This
   maps horizontal wheel intent onto Flickity's own animated next()/previous(), so the carousel becomes
   scrollable that way without disturbing its drag, autoplay, or positional stagger. Vertical scroll is
   left untouched so the page still scrolls normally over the carousel.

   Editor-resilient: re-points at the fresh instance on every co-flickity:init (section re-render). */
(function () {
  if (window.__coFlickityWheel) return;
  window.__coFlickityWheel = true;

  var SELECTOR = '[data-co-flickity]:not([data-co-flickity-no-wheel])';
  var THRESHOLD = 25; // px of horizontal scroll per one-cell step (lower = more fluid / less "arrow-like")
  var STEP_DELAY = 180; // ms cooldown between slide steps — rate-limits aggressive/momentum scrolls

  function attach(carousel, flkty) {
    if (!carousel || !flkty) return;
    // Always keep a pointer to the CURRENT instance — co-flickity rebuilds it on section:load, and the
    // listener (bound once) reads this dynamically so it never calls into a destroyed instance.
    carousel.__coWheelFlkty = flkty;
    if (carousel.__coWheelBound) return;
    carousel.__coWheelBound = true;

    var accum = 0;
    var lastStep = 0;

    carousel.addEventListener(
      'wheel',
      function (event) {
        var instance = carousel.__coWheelFlkty;
        if (!instance) return;

        // Horizontal amount: the native deltaX when it dominates, else deltaY while Shift is held.
        var dx = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : (event.shiftKey ? event.deltaY : 0);
        if (!dx) return; // a vertical scroll — let the page handle it

        // Consume the horizontal scroll: moves the carousel AND prevents the browser back/forward swipe.
        event.preventDefault();

        // ONE step per cooldown window: aggressive flicks / trackpad momentum fire dozens of wheel
        // events, and stepping Flickity on each restarts its slide animation over and over — the
        // "laggy" stutter on heavy sections. Deltas that arrive during the cooldown are ABSORBED
        // (not accumulated), so a hard flick doesn't queue up slides that keep firing after the
        // gesture ends; the slider advances at most one cell per STEP_DELAY, animating cleanly.
        var now = Date.now();
        if (now - lastStep < STEP_DELAY) {
          accum = 0;
          return;
        }

        accum += dx;
        if (Math.abs(accum) >= THRESHOLD) {
          if (accum > 0) {
            instance.next();
          } else {
            instance.previous();
          }
          accum = 0;
          lastStep = now;
        }
      },
      { passive: false }
    );
  }

  // Real-time path: co-flickity fires this per carousel and again on every editor re-init.
  document.addEventListener('co-flickity:init', function (event) {
    var el = event.target;
    if (el && el.matches && el.matches(SELECTOR)) attach(el, event.detail && event.detail.flickity);
  });

  // Load-order safety net: co-flickity may have initialised before this listener registered — it stores
  // the instance on el.__flkty.
  function scanExisting() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.__flkty) attach(el, el.__flkty);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanExisting);
  } else {
    scanExisting();
  }
})();
